/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_Offset_FramesInputs */



/**
* | output |
* | --- |
* | "Shot Change Offset (Frames)" |
*
* @param {Shot_Change_Offset_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_offset_frames = /** @type {((inputs?: Shot_Change_Offset_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_Offset_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décalage du changement de plan (images)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungswechsel-Versatz (Frames)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset del cambio di inquadratura (fotogrammi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смещение при смене кадра (кадры)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento del cambio de toma (fotogramas)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头切换偏移量（帧）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット変更オフセット（フレーム）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन ऑफ़सेट (फ्रेम)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento de mudança de tomada (quadros)")
	return /** @type {LocalizedString} */ ("Shot Change Offset (Frames)")
});